import previewExcel from './index.vue';

export default {
  install(Vue, options) {
    Vue.prototype.$previewExcel = function(opt) {
      // 继承messageBox组件
      const PreviewExcelConstructor = Vue.extend(previewExcel);
      // 创建一个新元素
      const PreviewExcelWrap = document.createElement('div');
      PreviewExcelWrap.className = 'preview-excel-wrap';
      // 实例化messageBox组件，并将组件挂在到新创建的message-box-wrap元素上
      const PreviewExcelInstace = new PreviewExcelConstructor({
        el: PreviewExcelWrap
      });
      // 或者使用 messageInstace.$mount(messageWrap)挂载
      document.body.appendChild(PreviewExcelInstace.$el);
      // 显示组件内容
      if (opt) {
        PreviewExcelInstace.data = opt.data;
        PreviewExcelInstace.title = opt.title;
        PreviewExcelInstace.download = opt.download;
      }
      PreviewExcelInstace.centerDialogVisible = true;
    };
  }
};



// WEBPACK FOOTER //
// ./src/libs/previewExcel/index.js